import NavBar from "../components/navBar/navBar";
import Footer from "../components/footer/footer";

const NavBarWithFooterLayout = ({ children }) => {
  return (
    <div>
      <div className={`flex flex-col`}>
        <NavBar />
        <main className="flex flex-col md:mt-[101px] mt-[113px] md:mb-[40px] mb-[80px] m-auto">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default NavBarWithFooterLayout;
